<script setup>
import { RouterLink, RouterView } from 'vue-router'
import { Head } from "@vueuse/head";
import { useAuthStore } from '@/stores/auth.store.js';


const authStore = useAuthStore();
authStore.init()
</script>

<template>
  <Head>
    <title>Impact Journals</title>
  </Head>

  <div class="app-container">
      <router-view />
  </div>
</template>